import { render, staticRenderFns } from "./AddFileBtnSelect.vue?vue&type=template&id=a166463c&"
import script from "./AddFileBtnSelect.vue?vue&type=script&lang=js&"
export * from "./AddFileBtnSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports